
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"30","height":"30","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"d":"M9.262 21.558a3.752 3.752 0 01-3.55-2.556l-.034-.116a3.658 3.658 0 01-.174-1.086V10.97l-2.43 8.114a2.275 2.275 0 001.595 2.76l15.493 4.15c.193.05.387.073.577.073.998 0 1.91-.662 2.165-1.638l.903-2.87H9.262z","fill":"#B4BCCF"}}),_c('path',{attrs:{"d":"M12.017 11.037a2.006 2.006 0 002.004-2.004 2.006 2.006 0 00-2.004-2.004 2.006 2.006 0 00-2.004 2.004c0 1.105.899 2.004 2.004 2.004z","fill":"#525F7F"}}),_c('path',{attrs:{"d":"M24.541 4.023H9.512a2.508 2.508 0 00-2.505 2.505V17.55a2.509 2.509 0 002.505 2.505h15.03a2.509 2.509 0 002.505-2.505V6.528a2.509 2.509 0 00-2.506-2.505zM9.512 6.027h15.03c.276 0 .5.224.5.501v7.113l-3.165-3.693a1.795 1.795 0 00-1.343-.616 1.751 1.751 0 00-1.339.632l-3.721 4.466-1.213-1.209a1.759 1.759 0 00-2.484 0L9.01 15.985V6.528c0-.277.225-.5.501-.5z","fill":"#525F7F"}}),_c('defs',[_c('clipPath',{attrs:{"id":"clip0"}},[_c('path',{attrs:{"fill":"#fff","transform":"translate(3 4)","d":"M0 0h24v24H0z"}})])])])
          )
        }
      }
    